import { API_INTEREST_CONFIGURABLES } from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_INTEREST_CONFIGURABLES } from "../../utils/urls";

export const useInterestConfigurablesForm = () => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "purpose",
          type: "select",
          label: "Purpose",
          props: { required: true },
          options_data: [
            { id: "boda", name: "Boda" },
            { id: "cash", name: "Cash" },
            { id: "car", name: "Car" },
          ],
        },
        {
          field_name: "interest",
          type: "text",
          label: "Interest",
          props: { required: true },
        },
        {
          field_name: "default",
          type: "checkbox",
          label: "Is Default",
        },
      ],
    },
  ];

  const redirect = getRegister(URL_INTEREST_CONFIGURABLES);

  return {
    sections,
    redirect,
  };
};

export function submitInterestConfigurables(payload: any, id: string) {
  //  on update
  if (id) {
    return {
      id,
      api: API_INTEREST_CONFIGURABLES,
      params: payload,
    };
  }
  // on create
  return {
    api: API_INTEREST_CONFIGURABLES,
    params: payload,
  };
}
